var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTopnavBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-topnav-bell",
    x: 0.761,
    y: 0.632,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-topnav-bell1",
    serifid: "iconR-topnav-bell",
    d: "M20.743,35.631c1.766,0 3.289,-1.189 3.618,-2.767c0.01,-0.047 -0.002,-0.096 -0.033,-0.133c-0.031,-0.037 -0.077,-0.058 -0.126,-0.058l-6.919,-0c-0.049,-0 -0.095,0.021 -0.126,0.058c-0.031,0.037 -0.043,0.086 -0.034,0.133c0.33,1.579 1.853,2.767 3.62,2.767Zm13.597,-7.993c-1.294,-1.315 -3.726,-3.288 -3.726,-9.764c0,-4.52 -3.36,-8.133 -7.882,-9.021c-0.234,-0.046 -0.399,-0.242 -0.399,-0.468l0,-1.274c0,-0.819 -0.705,-1.48 -1.571,-1.48c-0.866,0 -1.572,0.661 -1.572,1.48c0,-0 0,1.274 0,1.274c0,0.226 -0.165,0.422 -0.398,0.468c-4.523,0.888 -7.883,4.501 -7.883,9.021c0,6.476 -2.431,8.449 -3.726,9.764c0,-0 0,-0 0,-0c-0.292,0.296 -0.424,0.649 -0.421,0.996c-0,0 -0,0 -0,0.001c0.005,0.761 0.64,1.482 1.579,1.482l24.841,0c0.94,0 1.575,-0.721 1.58,-1.482c-0,-0 -0,-0 -0,-0.001c0.002,-0.346 -0.13,-0.7 -0.422,-0.996c0,-0 0,-0 0,-0Zm-5.831,-9.767c0,-0 -0.003,0.112 -0.003,0.133c0.014,4.956 1.447,7.601 2.774,9.358c0.175,0.232 0.203,0.276 0.335,0.419c0.237,0.257 -0.045,0.325 -0.261,0.325l-21.184,-0c-0.224,-0 -0.495,-0.094 -0.263,-0.325c0.07,-0.071 0.254,-0.316 0.332,-0.413c1.329,-1.655 2.775,-4.434 2.779,-9.426l-0.004,-0.068c0,-4.045 3.467,-7.327 7.748,-7.327c4.279,0 7.745,3.28 7.747,7.324Z",
    style: {
      fill: "#808080",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTopnavBell);
export default __webpack_public_path__ + "static/media/iconR-topnav-bell.b6ec9bc1aaf8e9a91935068e31a94c86.svg";
export { ForwardRef as ReactComponent };